import { useTranslation } from "react-i18next";
import KiloNewton from "../../../../../components/Math/Units/Metric/KiloNewton";
import { NumberFormatText } from "../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../components/ToolTip";

function ZulaessigeBemessungsschwingbreite({ zulaessigeBemessungsschwingbreite }) {
  const { t } = useTranslation("translation");
  const R_d_delta_sigma_Formula = `\\displaystyle R_{d,Δσ} = \\frac{R_{d,Δσ}}{\\gamma_{\\tiny _{Mf}}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.fatigue.permissibleDesignStressRange")}</p>}
      formulaValue={
        <ToolTip
          id={"R_d_delta_sigma_Formula"}
          type={IconType.FORMULA}
          formula={R_d_delta_sigma_Formula}
        />
      }
      indicesValue={
        <span>
          R<sub>d,Δσ</sub>
        </span>
      }
      inputValue={
        <span className="input">
          <NumberFormatText value={zulaessigeBemessungsschwingbreite} decimalScale={1} />
        </span>
      }
      unitValue={<KiloNewton />}
    />
  );
}

export default ZulaessigeBemessungsschwingbreite;
